export default {
  女装: "ayollar kiyimi",
  男装: "Erkaklar",
  手机和小工具: "Mobil telefonlar va gadjetlar",
  居家生活: "uy hayoti",
  电脑及周边设备: "Kompyuterlar va periferik uskunalar",
  美容及个人护理: "Go'zallik va shaxsiy parvarish",
  家用电器: "maishiy texnika",
  健康与保健: "salomatlik va farovonlik",
  食品和饮料: "oziq-ovqat va ichimliklar",
  玩具_儿童和婴儿: "o'yinchoqlar, bolalar va chaqaloqlar",
  童装时尚: "bolalar modasi",
  视频游戏: "video O'yinlar",
  运动与户外: "Sport va ochiq havoda",
  爱好与书籍: "Sevimli mashg'ulotlar va kitoblar",
  相机和无人机: "Kameralar va dronlar",
  宠物食品及用品: "Uy hayvonlari uchun oziq-ovqat va materiallar",
  女士包袋: "ayollar sumkalari",
  男士包袋: "erkaklar sumkalari",
  珠宝及配饰: "Zargarlik va aksessuarlar",
  手表: "tomosha qiling",
  女鞋: "ayollar poyabzali",
  男装鞋: "erkaklar poyabzali",
  汽车: "mashina",
  我附近的ShopeePay: "Menga yaqin ShopeePay",
  餐饮_旅行和服务: "Ovqatlanish, sayohat va xizmatlar",
  旅行及行李: "Sayohat va bagaj",
  各种各样的: "Turli xil turlari",
  我是来买什么的: "Men nima sotib olish uchun keldim?",
  对不起_找不到_相关的商品: "Kechirasiz, [{0}] ga tegishli mahsulot topilmadi",
  类别: "kategoriya",
  产品: "mahsulot",
  店铺: "do'kon",
  首页: "oldingi sahifa",
  限时秒杀: "Cheklangan vaqtli flesh-sotiq",
  博客: "blog",
  所有品牌: "Barcha brendlar",
  所有类别: "Barcha toifalar",
  我的购物车: "mening xarid qilish savatim",
  发货信息: "yetkazib berish ma'lumotlari",
  交货信息: "Yetkazib berish haqida ma'lumot",
  付款: "To'lov",
  确认: "tasdiqlang",
  您的购物车是空的: "Savatingiz boʻsh",
  价格: "narx",
  税: "Soliq",
  数量: "miqdori",
  总计: "jami",
  移除: "O'chirish",
  返回商店: "Do'konga qaytish",
  继续发货: "Yetkazib berishda davom eting",
  筛选: "filtr",
  价格范围: "narx oralig'i",
  排序方式: "saralash turi",
  最新: "hozirgi kungacha",
  最旧: "eng qadimgi",
  价格从低到高: "Narx pastdan yuqoriga",
  价格从高到低: "Narx yuqoridan pastgacha",
  选择交货类型: "Yetkazib berish turini tanlang",
  送货上门: "Yetkazib berish",
  继续付款: "To'lashda davom eting",
  任何其他信息: "har qanday boshqa ma'lumotlar",
  或者: "yoki",
  您的钱包余额: "Sizning hamyoningiz balansi",
  余额不足: "Balans yetarli emas",
  支付: "to'lash",
  我同意: "Men roziman",
  条款和条件: "foydalanish shartlari",
  退货政策: "qaytarish siyosati",
  隐私政策: "Maxfiylik siyosati",
  概括: "umumlashtirish",
  项目: "loyiha",
  全部的: "hammasi",
  小计: "Oraliq jami",
  总运费: "umumiy yuk narxi",
  有优惠码吗_在这里输入: "Chegirma kodi bormi? bu yerga kiring",
  申请: "Murojaat qiling",
  编辑: "tahrirlash",
  删除: "o'chirish",
  添加新地址: "yangi manzil qo'shing",
  继续交货信息: "Etkazib berish ma'lumotlarini davom ettiring",
  选择一个地址: "Manzilni tanlang",
  购买历史: "Sotib olish tarixi",
  下载: "yuklab oling",
  已发送退款请求: "Toʻlovni qaytarish soʻrovi yuborildi",
  对比: "Taqqoslangan",
  对话: "dialog",
  我的钱包: "Mening hamyonim",
  工单: "ish tartibi",
  管理个人资料: "Profilni boshqarish",
  登出: "tizimdan chiqish",
  重置对比列表: "Taqqoslash ro'yxatini tiklash",
  您的对比列表为空: "Taqqoslash roʻyxati boʻsh",
  在您的购物车中: "xarid qilish savatingizda",
  在您的愿望清单中: "istaklaringiz ro'yxatida",
  在您的预定列表中: "bronlash ro'yxatida",
  下载您的产品: "Mahsulotingizni yuklab oling",
  选项: "Variantlar",
  什么都没找到: "hech narsa topilmadi",
  特色产品: "Tanlangan mahsulotlar",
  最畅销: "bozori chaqqon",
  前_名: "Top {0}",
  查看更多: "ko'proq ko'ring",
  查看所有类别: "Barcha toifalarni ko'rish",
  十大品牌: "Eng yaxshi o'nta brend",
  查看所有品牌: "Barcha brendlarni ko'ring",
  登录: "Tizimga kirish",
  手机号码: "telefon raqami",
  密码: "parol",
  密码长度为6到16个字符: "Parol uzunligi 6 dan 16 gacha",
  验证码: "Tasdiq kodi",
  登录中: "tizimga kirish",
  游客登录: "Mehmonga kirish",
  注册您的商店: "Do'koningizni ro'yxatdan o'tkazing",
  现在申请: "Hozir murojaat qiling",
  成为商家: "Savdogar bo'l",
  现在注册: "Hozir roʻyxatdan oʻting",
  登录成功: "kirish muvaffaqiyatli",
  通知: "xabar bering",
  未找到通知: "bildirishnoma topilmadi",
  评论: "Izoh",
  估计运输时间: "Taxminiy etkazib berish vaqti",
  天: "osmon",
  所售: "sotilgan",
  给商家留言: "Savdogarga xabar qoldiring",
  规格: "Spetsifikatsiya",
  库存: "omborda mavjud; sotuvda mavjud",
  总价: "umumiy narx",
  添加到购物车: "savatchaga qo'shish",
  立即购买: "Hozir xarid qilish",
  缺货: "sotuvda yo'q",
  添加到愿望清单: "Istaklar ro'yxatiga qo'shing",
  加入对比列表: "Taqqoslash ro'yxatiga qo'shing",
  退款: "To'lovni qaytarish",
  查看条款: "Shartlarni ko'rish",
  分享: "baham ko'ring",
  描述: "tasvirlab bering",
  相关产品: "Tegishli mahsulotlar",
  没有人问过商家: "Savdogarlardan hech kim so‘ramadi",
  该产品暂无评论: "Ushbu mahsulot uchun hali hech qanday sharhlar mavjud emas",
  客户评论: "mijozlar sharhlari",
  访问商店: "do'konga tashrif buyuring",
  畅销产品: "Bestsellerlar",
  日期: "sana",
  订单编号: "buyurtma raqami",
  总额: "bir martalik to'lov",
  状态: "davlat",
  愿望清单: "istaklar roʻyxati",
  还没有添加任何东西: "Hali hech narsa qo'shilmagan",
  注册: "ro'yxatdan o'tish",
  邀请码: "Taklif kodi",
  请输入邀请码: "Iltimos, taklif kodini kiriting",
  用户名: "foydalanuvchi nomi",
  请输入用户名: "foydalanuvchi nomini kiriting",
  用户名长度为6_14个字符: "Foydalanuvchi nomi uzunligi 6-14 belgidan iborat",
  昵称: "Taxallus",
  请输入手机号码: "Iltimos, telefon raqamini kiriting",
  手机号码格式错误: "Telefon raqamining noto'g'ri formati",
  密码长度为6_16个字符: "Parol uzunligi 6-16 belgidan iborat",
  确认密码: "Parolni tasdiqlang",
  请输入确认密码: "Iltimos, tasdiqlash parolini kiriting",
  提款密码: "Pul o'tkazish uchun parol",
  请输入提款密码: "Iltimos, yechib olish parolini kiriting",
  提款密码长度为4_16个字符:
    "Pulni olish uchun parol uzunligi 4-16 belgidan iborat",
  请输入验证码: "tasdiqlash kodini kiriting",
  在_s后发送: "{0} soniyadan keyin yuborildi",
  发送验证码: "Tasdiqlash kodini yuboring",
  注册即表示您同意我们的条款和条件:
    "Ro'yxatdan o'tish orqali siz bizning shartlarimizga rozilik bildirasiz.",
  创建账号: "Hisob ochish",
  验证码发送成功: "Tasdiqlash kodi muvaffaqiyatli yuborildi",
  确认密码不一致: "Parolning mos kelmasligini tasdiqlang",
  提款密码必须为数字: "Pul o'tkazish paroli raqamli bo'lishi kerak",
  注册成功: "ro'yxatga olish muvaffaqiyati",
  购物车: "xarid savati",
  账户: "Hisob",
  我的账户: "mening hisobim",
  已经有一个账户: "Allaqachon hisobingiz bor",
  新地址: "yangi manzil",
  编辑地址: "Manzilni tahrirlash",
  保存: "saqlash",
  是否默认: "Bu standartmi",
  具体地址: "Maxsus manzil",
  请输入具体地址: "Iltimos, aniq manzilni kiriting",
  地区: "hudud",
  请输入地区: "Iltimos, mintaqani kiriting",
  城市: "Shahar",
  请输入城市: "Iltimos, shaharni kiriting",
  省份: "viloyat",
  请输入省份: "Iltimos, viloyatni kiriting",
  邮政编码: "Pochta kodi",
  请输入邮政编码: "Iltimos, pochta indeksini kiriting",
  电话号码: "telefon raqami",
  请输入电话号码: "Iltimos, telefon raqamingizni kiriting",
  收货人: "Qabul qiluvchi",
  请输入收货人: "Iltimos, qabul qiluvchini kiriting",
  保存成功: "Muvaffaqiyatli saqlandi",
  最畅销的商家: "Eng ko'p sotiladigan savdogarlar",
  查看所有的商家: "Barcha bizneslarni ko'rish",
  支持政策: "Qo'llab-quvvatlash siyosati",
  您的电子邮件地址: "Sizning e-pochta manzilingiz",
  订阅: "obuna",
  联系方式: "Bog'lanish uchun ma'lumot",
  地址: "manzil",
  美国伊利诺伊州霍夫曼庄园: "Hoffman Estates, Illinoys, AQSH",
  快速链接: "Tez havolalar",
  商家政策: "Savdogar siyosati",
  submit: "topshirish",
  提款银行卡: "Pul olish uchun bank kartasi",
  我的面板: "mening panelim",
  提示: "ishora",
  确定登出吗: "Haqiqatan ham tizimdan chiqmoqchimisiz?",
  确定: "Albatta",
  取消: "Bekor qilish",
  项目添加到您的购物车: "Savatingizga mahsulotni qo'shing",
  经常一起购买: "tez-tez birga sotib oling",
  返回购物: "Xarid qilish sahifasiga qaytish",
  进行结算: "Ro'yxatdan o'chirilishda davom etish",
  帮助热线: "Ishonch telefoni",
  查看所有通知: "Barcha bildirishnomalarni ko'rish",
  请输入密码: "Iltimos, parolni kiriting",
  前往充值: "To'ldirishga o'ting",
  购物车物品: "Savatga buyumlari",
  查看购物车: "xarid qilish savatini tekshiring",
  钱包余额: "hamyon balansi",
  充值钱包: "Hamyonni to'ldirish",
  钱包充值_线下_: "Hamyonni toʻldirish (oflayn)",
  申请提款: "Pul olish uchun ariza bering",
  钱包收支明细: "Hamyon daromadlari va xarajatlari tafsilotlari",
  批准: "ma'qullash",
  提现历史记录: "Olib tashlash tarixi",
  类型: "turi",
  信息: "ma `lumot",
  付款方式: "to'lov usuli",
  请选择付款方式: "Toʻlov usulini tanlang",
  Bill_Type_RECHARGE_BACK: "Orqa qismni qayta zaryadlash",
  Bill_Type_RECHARGE_ONLINE: "Onlayn zaryadlash",
  Bill_Type_RECHARGE_REGISTER: "Bepul ro'yxatdan o'ting",
  Bill_Type_RECHARGE_JACKPOT: "Bonusni to'ldirish",
  Bill_Type_RECHARGE_PRESENT: "Mukofotlarni to'ldirish",
  Bill_Type_RECHARGE_FROM_COMMISSION: "Komissiya o'tkazish",
  Bill_Type_RECHARGE_TG_COMMISSION: "Rag'batlantiruvchi komissiyani to'ldirish",
  Bill_Type_REGISTER_TG_COMMISSION:
    "Ro'yxatga olishni rag'batlantirish komissiyasi",
  Bill_Type_WITHDRAW: "chekinmoq",
  Bill_Type_WITHDRAW_REJECT: "Olib tashlash rad etildi",
  Bill_Type_DEDUCT_HANDLE: "Qo'lda chegirma",
  Bill_Type_DEDUCT_RECHARGE_MONEY: "Zaryadni to'g'irlash",
  Bill_Type_MINING_PROFIT: "Konchilikdan olingan daromad",
  Bill_Type_MINING_PROFIT_COMMISSION:
    "Tog'-kon daromadlarini rag'batlantirish komissiyasi",
  Bill_Type_VIP_UPGRADE: "VIP-ni yangilang",
  Bill_Type_FINANCE_BUY: "Moliyaviy mahsulotlarni sotib oling",
  Bill_Type_FINANCE_CAPITAL_RETURN: "Moliyaviy balansning qaytarilishi",
  Bill_Type_FINANCE_FEE: "Moliyaviy boshqaruv to'lovlari",
  Bill_Type_FINANCE_PROFIT: "Moliyaviy boshqaruv daromadlari",
  Bill_Type_FINANCE_BUY_COMMISSION:
    "Moliyaviy mahsulotlarni sotib olish uchun komissiya",
  Bill_Type_FINANCE_PROFIT_COMMISSION:
    "Moliyaviy mahsulotdan olinadigan daromad komissiyasi",
  Bill_Type_WHEEL_DRAW: "Katta g'ildirak lotereyasi",
  Bill_Type_BUY: "tovarlar sotib olish",
  Bill_Type_PAY_SHOP: "Yuk tashish uchun to'lov",
  Bill_Type_BUY_COMMISSION: "Sotib olingan narsalar uchun komissiya",
  Bill_Type_DEPOSIT: "Depozitni to'lash",
  Bill_Type_STORE_BUY: "tovarlar sotib olish",
  Bill_Type_STORE_BUY_REFUND: "Sotib olingan mahsulot to'lovini qaytarish",
  Bill_Type: "Hisobni o'zgartirish turi",
  Before_Money: "oldingi miqdor",
  Deal_Money: "Hisobni o'zgartirish miqdori",
  After_Money: "Miqdori keyin",
  Bill_Time: "Hisobni o'zgartirish vaqti",
  No_More_Data: "boshqa ma'lumotlar yo'q",
  Apply_Money: "Ariza miqdori",
  Apply_Time: "qo'llash vaqti",
  Withdraw_Info: "Ishlov berish narxi: {fee}, yetib kelish: {money}",
  提款订单状态_CHECKING: "Ko‘rib chiqish kutilmoqda",
  提款订单状态_TRANSFERRING: "Oʻtkazilmoqda",
  提款订单状态_PASS: "tasdiqlangan",
  提款订单状态_REJECT: "Rad etilgan",
  暂无可用充值方式: "To'ldirish usuli hali mavjud emas",
  钱包收款码: "Hamyon to'lov kodi",
  钱包地址: "hamyon manzili",
  金额限制: "Miqdor chegarasi",
  复制: "nusxa ko'chirish",
  付款凭证: "to'lov vaucheri",
  收款银行: "Benefisiar bank",
  收款人: "To'lovchi",
  收款账号: "To'lov hisob raqami",
  付款银行: "to'lov banki",
  付款人: "To'lovchi",
  付款账号: "To'lov hisobi",
  请输入付款银行: "Iltimos, to'lov bankini kiriting",
  请输入付款人: "Iltimos, to'lovchini kiriting",
  请输入付款账号: "Iltimos, to'lov hisob raqamini kiriting",
  请上传付款凭证: "Iltimos, toʻlov vaucherini yuklang",
  充值金额: "To'ldirish miqdori",
  请输入充值金额: "Iltimos, to'lov miqdorini kiriting",
  submitting: "topshirilmoqda...",
  Confirm: "topshirish",
  Commit_Success: "Muvaffaqiyatli topshirildi",
  balanceType_BALANCE: "Balans",
  balanceType_COMMISSION: "komissiya",
  Balance: "Hisob balansi",
  Wash_Money: "mozaika qo'shing",
  请选择银行账户: "Bank hisobini tanlang",
  卡号类型: "Karta raqami turi",
  提现金额: "Yechib olish miqdori",
  提款金额: "Olib tashlash miqdori",
  不能为空: "Bo'sh bo'lishi mumkin emas",
  金额不正确: "Miqdor noto'g'ri",
  please_input_withdraw_password: "Iltimos, yechib olish parolini kiriting",
  withdraw_password_format_error:
    "Pulni olish uchun parol 4-16 belgidan iborat bo'lishi kerak",
  Fee: "ishlov berish to'lovi",
  实际到账: "Haqiqiy kelish",
  交易币种: "Tranzaksiya valyutasi",
  原始密码: "original parol",
  confirm_password_error: "Ikki marta kiritilgan parol noto'g'ri",
  save_success: "Muvaffaqiyatli saqlandi",
  please_input: "iltimos kiriting",
  old_password: "Eski parol",
  new_password: "Yangi parol",
  please_input_confirm_password: "Parolni qayta tasdiqlang",
  没有找到符合条件的商品: "Hech qanday mos mahsulot topilmadi",
  Search: "qidirmoq",
  全部: "hammasi",
  EnumGoodsOrderState_USER_PAY: "Yetkazib berish kutilmoqda",
  EnumGoodsOrderState_SHOP_PAY: "Yetkazib berish",
  EnumGoodsOrderState_SUCCESS: "Tugatish",
  EnumGoodsOrderState_CANCEL: "Bekor qilingan",
  EnumGoodsOrderState_REFUND_SUCCESS: "qaytarilgan",
  订单号: "buyurtma raqami",
  用户名称: "foydalanuvchi nomi",
  收益: "daromad",
  支付时间: "To'lov vaqti",
  配送时间: "Yetkazib berish vaqti",
  完成时间: "To'liq vaqt",
  发货: "Kema",
  全选: "hammasini belgilash",
  物品已添加到愿望清单: "Ob'ekt istaklar ro'yxatiga qo'shildi",
  物品已添加到比较列表: "Element taqqoslash ro'yxatiga qo'shildi",
  购买成功提示: "Tabriklaymiz, xaridingiz muvaffaqiyatli bo'ldi",
  订单列表: "Buyurtma ro'yxati",
  商品名: "Mahsulot nomi",
  图片: "rasm",
  没有品牌: "brend yo'q",
  基本信息: "Asosiy ma'lumotlar",
  Account_Name: "Hisobni ochish nomi",
  Bank_Account: "Bank hisob raqami",
  Bank_Phone: "Mobil telefon raqamini zaxiralang",
  IFSC: "IFSC hisobi",
  UPI: "UPI hisobi",
  PIX: "PIX hisobi",
  CPF: "CPF hisobi",
  GCASH: "GCASH hisobi",
  POWWI: "POWWI hisobi",
  身份证号: "ID raqami",
  Edit: "Qayta ko'rib chiqish",
  Delete: "o'chirish",
  Add: "Yangi",
  Forget_Withdraw_Password: "Pul o'tkazish parolini unutdingiz",
  Bank_Card_Info: "Bank kartasi ma'lumotlari",
  收款人地址: "To'lovchi manzili",
  SWIFT: "SWIFT",
  Bank_Branch: "Filial nomi",
  分行代码: "filial kodi",
  银行地址: "Bank manzili",
  Email: "Elektron pochta",
  银行卡长度必须超过: "Bank kartasining uzunligi {length} dan oshmasligi kerak",
  银行卡格式不正确: "Bank kartasi formati noto‘g‘ri",
  Do_you_confirm_delete: "Oʻchirish tasdiqlansinmi?",
  Please_Login_First: "Iltimos, avval tizimga kiring",
  Bank_Name: "Bank nomi",
  Please_add_bank_first:
    "Siz hali bank kartangizni bog‘lamagansiz, avval uni qo‘shing",
  withdrawType: "Olib tashlash turi",
  withdraw_money_limit:
    "Pul yechib olish miqdori 0 dan katta va {balance} dan kichik yoki teng boʻlishi kerak",
  withdraw_times_limit:
    "Siz bugun {todayWithdrawNum} marta yechib oldingiz va {limitTimes} martadan keyin {withdrawFee}% ishlov berish toʻlovi undiriladi. Chiqib ketishingizga ishonchingiz komilmi?",
  Copy_Success: "Muvaffaqiyatli nusxalandi",
  商店首页: "Do'konning bosh sahifasi",
  所有产品: "Barcha mahsulotlar",
  新到货产品: "Yangi kelgan mahsulotlar",
  所有商家: "Barcha savdogarlar",
  请上传: "Iltimos yuklang",
  请输入: "iltimos kiriting",
  忘记密码: "parolni unuting",
  记得我: "meni eslaysizmi",
  共_件: "Jami {0} ta element",
  取消订单: "buyurtmani bekor qilish",
  申请退款: "To'lovni qaytarishni talab qiling",
  未知商家: "Noma'lum savdogar",
  到账: "Kvitansiya",
  提款订单状态: "Buyurtmani qaytarib olish holati",
  前_名类别: "Eng yaxshi {0} toifalar",
  取消订单原因_不想要了: "Endi buni xohlamang",
  取消订单原因_商品错选_多选: "Mahsulotni noto'g'ri tanlash/bir nechta tanlov",
  取消订单原因_商品无货: "Mahsulot zaxirada yo‘q",
  取消订单原因_地址信息填写错误: "Manzil ma'lumotlari noto'g'ri to'ldirilgan",
  取消订单原因_商品降价: "Mahsulot narxini pasaytirish",
  取消订单原因_价格高于其他平台:
    "Narx boshqa platformalarga qaraganda ancha yuqori",
  取消订单原因_没用_少用_错用优惠:
    "Chegirmalardan foydalanish yo'q/kamroq foydalanish/noto'g'ri foydalanish",
  退款原因_拍错_多拍_不喜欢: "Noto'g'ri zarba / qo'shimcha zarba / yoqmaydi",
  退款原因_商品成分描述不符: "Mahsulot tarkibi tavsifi mos kelmaydi",
  退款原因_与商家协商一致退款:
    "To'lovni sotuvchi bilan kelishilgan holda qaytarish",
  退款原因_生产日期_保质期与商品描述不符:
    "Ishlab chiqarish sanasi/yaroqlilik muddati mahsulot tavsifiga mos kelmaydi",
  退款原因_图片_产地_批号_规格等描述不符:
    "Rasmlar/kelib chiqishi/partiya raqami/spetsifikatsiyalari va boshqa tavsiflar mos kelmaydi",
  退款原因_质量问题: "Sifat muammolari",
  退款原因_商品变质_发霉_有异物:
    "Mahsulot buzilgan / mog'orlangan / begona moddalar mavjud",
  退款原因_少件_含缺少配件_:
    "Bir nechta qismlar (shu jumladan etishmayotgan aksessuarlar)",
  退款原因_收到商品时有破损_污渍_变形:
    "Buyum qabul qilinganda shikastlangan/bo'yalgan/deformatsiyalangan.",
  退款原因_假冒品牌: "Soxta brendlar",
  退款原因_发票问题: "Hisob-faktura muammolari",
  退款原因_商家发错货: "Savdogar noto'g'ri tovarlar yuborgan",
  退款原因_预约不到_商家不给退换:
    "Uchrashuvni belgilab bo'lmaydi/sotuvchi qaytarib bermaydi yoki almashtirmaydi",
  退款失败: "Toʻlov qaytarilmadi",
  退款处理中: "Toʻlovni qaytarish davom etmoqda",
  默认: "standart",
  产品查询: "Mahsulot qidirish",
  商店LOGO: "LOGO saqlash",
  推广码: "Promo-kod",
  查看所有: "hammasini ko'rish",
  确认收货成功: "Tovarlarni muvaffaqiyatli qabul qilishni tasdiqlang",
  物流公司: "Logistika kompaniyasi",
  物流单号: "jo'natish raqami",
  发货时间: "Yetkazib berish vaqti",
  请先选择商品规格:
    "Iltimos, avval mahsulotning texnik xususiyatlarini tanlang",
  个人信息: "Shaxsiy ma'lumot",
  您的用户名: "foydalanuvchi nomingiz",
  你的名字: "ismingiz",
  登录名: "foydalanuvchi nomi",
  你的邮件: "sizning elektron manzilingiz",
  你的密码: "parolingiz",
  重复输入密码: "Parolni qayta kiriting",
  店铺名称: "Do'kon nomi",
  证书类型: "Sertifikat turi",
  身份证: "ID karta",
  护照: "pasport",
  驾驶执照: "haydovchilik guvohnomasi",
  社会保障卡: "Ijtimoiy sug'urta kartasi",
  证书正面: "Sertifikat old tomoni",
  证书反面: "Sertifikatning orqa tomoni",
  确认收货: "tovarlarni qabul qilishni tasdiqlash",
  请选择取消订单的原因必选:
    "Buyurtmani bekor qilish sababini tanlang (majburiy):",
  请选择申请退款的原因必选:
    "To'lovni qaytarishni so'rash sababini tanlang (majburiy):",
  留言: "xabar",
  请输入留言: "Iltimos, xabar kiriting",
  没有帐户: "Hisob yo'q",
  钱包充值: "Hamyonni to'ldirish",
  输入您的文字: "Matningizni kiriting",
  商家登录: "Savdogar login",
  有关此产品的任何查询: "Ushbu mahsulot haqida har qanday so'rov",
  产品名称: "Mahsulot nomi",
  你的问题: "sizning muammoingiz",
  白银店铺: "kumush do'koni",
  铂金店铺: "platina do'koni",
  钻石店铺: "olmos do'koni",
  照片: "surat",
  已退货: "Qaytgan",
  邮寄状态: "Pochta holati",
  订单摘要: "Buyurtma xulosasi",
  收件地址: "Qabul qiluvchining manzili",
  订购日期: "Buyurtma sanasi",
  订单状态: "Buyurtma holati",
  总订单金额: "Buyurtmaning umumiy miqdori",
  邮寄方式: "Pochta yuborish usuli",
  附加信息: "Qo'shimcha ma'lumot",
  订单详细信息: "Buyurtma tafsilotlari",
  交货类型: "Yetkazib berish turi",
  进行评论: "Fikr bildiring",
  已评论: "Fikr bildirildi",
  订单金额: "buyurtma miqdori",
  优惠券: "kupon",
  统一运费: "Bir tekis etkazib berish to'lovi",
  送货地址: "Yetkazib berish manzili",
  评分: "Xol",
  你的意见: "sizning fikringiz",
  匿名: "anonim",
  现金: "naqd pul",
  详情: "Tafsilotlar",
  收货地址: "Yetkazib berish manzili",
  暂时没有对话: "Hali suhbat yo'q",
  你: "siz",
  输入您的回复: "Javobingizni kiriting",
  删除成功: "muvaffaqiyatli o'chirildi",
  品牌: "brend",
  已缴纳的保证金: "Xavfsizlik depoziti to'langan",
  黄金店铺: "oltin do'koni",
  没有更多数据: "boshqa ma'lumotlar yo'q",
  站内信: "Sayt xabari",
  系统通知: "tizim xabarnomasi",
  邮箱: "Pochta",
  手机号: "Telefon raqami",
  你的手机号: "telefon raqamingiz",
  营业执照: "tadbirkorlik litsenziyasi",
  你的邮箱: "sizning pochta qutingiz",
  搜索结果: "Qidiruv natijalari",
  系统公告: "tizim xabarnomasi",
  客服: "mijozlarga xizmat ko'rsatish",
  消息已撤回: "Xabar olib tashlandi",
  物流详情: "Logistika tafsilotlari",
  充值: "to'ldirish",
  提现: "chekinmoq",
  信用分: "kredit reytingi",
  余额: "Balans",
  佣金: "komissiya",
  继续购物: "xarid qilishda davom eting",
  订单结算: "Buyurtmani hisoblash",
  加入对比: "Taqqoslash uchun qo'shing",
  佣金余额: "Komissiya balansi",
  刷新: "yangilash",
  刷新成功: "Yangilash muvaffaqiyatli",
  官网: "Rasmiy veb-sayt",
  税号: "Soliq ID raqami",
  订单: "Buyurtma",
  合计: "jami",
  系统安全: "Tizim xavfsizligi",
  Recharge_Money_Limit:
    "Toʻldirish miqdori {min} va {max} orasida boʻlishi kerak",
  限时优惠: "Cheklangan vaqt taklifi",
  高价回收: "Yuqori narxdagi qayta ishlash",
  姓名: "Ism",
  商品订单号: "Mahsulot buyurtma raqami",
  商品在线回收: "Mahsulotni onlayn qayta ishlash",
  提交: "topshirish",
  回收记录: "Qayta ishlash yozuvlari",
  回收状态: "Qayta ishlash holati",
  回收价格: "qayta ishlash narxi",
  纳税码: "soliq kodeksi",
  买家登录: "Tizimga kirish",
  买家注册: "ro'yxatdan o'tish",
  language: "乌兹别克斯坦",
  助力提示:
    "Savdogarlar savdogarlar platformalarining do'konlariga ta'sirini kuchaytirishi va ko'p miqdordagi kunlar qanchalik yuqori bo'lsa, shuncha yuqori bo'ladi.",
  已累计助力: "Kümülatif yordam beradi",
  今日已助力: "Bugun yordam berdi",
  立即助力: "Darhol yordam bering",
  商家助力: "Savdogar yordam",
  证件号码: "ID raqami",
  证书号码: "Sertifikat raqami",
  男鞋: "Erkaklar poyafzali",
  游戏玩具: "O'yin o'yinchoqlari",
  使用条款: "foydalanish shartlari",
  商家: "Savdogar",
  已助力: "Yordam berdi",
  被助力: "Yordam berish",
  用户: "foydalanuvchi",
  助力记录: "Yozuv yozish",
  消息类型: "Xabar turi",
  消息内容: "Xabar tarkibi",
  链接: "Bog'lamoq",
  文本: "matn",
  清空: "Aniq",
  评论成功: "Fikr muvaffaqiyatli",
  扫描二维码: "QR kodini skanerlang",
  转入: "ichiga o'tkazish",
  收款: "To'plam",
  任务下单中心: "Vazifalarni buyurtma qilish markazi",
  记录: "rekord",
  任务倒计时: "Vazifani ortga hisoblash",
  倒计时后自动放弃: "Ortga hisoblashdan keyin avtomatik ravishda voz keching",
  业务码: "Biznes kodi",
  选择商品分类: "Mahsulot toifasini tanlang",
  可多选: "Bir nechta tanlovlar mumkin",
  加载分类中: "Kategoriyalar yuklanmoqda",
  暂无分类: "Hali tasnif yo'q",
  产品类别: "Mahsulot toifasi",
  账户余额: "Hisob balansi",
  立即结算: "Darhol hisob-kitob qilish",
  任务已自动放弃: "Vazifa avtomatik ravishda bekor qilindi",
  商品分类: "Mahsulot tasnifi",
  订单详情: "Buyurtma tafsilotlari",
  预计收益: "Taxminiy daromad",
  预计佣金收益: "Hisoblangan komissiya daromadi",
  收益率: "Hosildorlik",
  扣款账户: "Debet hisobi",
  确认结算: "Hisob-kitobni tasdiqlang",
  未选择: "Tanlanmagan",
  请选择商品分类: "Iltimos, mahsulot toifasini tanlang",
  下单成功: "Buyurtma muvaffaqiyatli topshirildi",
  下单失败: "Buyurtma bajarilmadi",
  请重试: "Iltimos, qayta urinib koʻring",
  订单记录: "Buyurtma yozuvi",
  没有更多了: "boshqa yo'q",
  业务号: "Biznes raqami",
  商品类型: "Mahsulot turi",
  佣金收益: "komissiya daromadi",
  待结算: "Kutilayotgan kelishuv",
  已结算: "Oʻrnatildi",
  已取消: "Bekor qilingan",
  加载失败: "Yuklanmadi",
  倒计时: "Ortga hisoblash",
  随机商品: "tasodifiy elementlar",
  为: "uchun",
  商户助力可提升商品曝光度:
    "Savdogar yordami mahsulot ta'sirini oshirishi mumkin",
  累计助力越高推荐权重越高:
    "Yig'ilgan yordam qanchalik yuqori bo'lsa, tavsiya etilgan og'irlik shunchalik yuqori bo'ladi.",
  实时助力动态: "Haqiqiy vaqtda yordam dinamikasi",
  助力奖励: "Mukofotlarni oshiring",
  随机奖励金额已生成: "Tasodifiy mukofot miqdori yaratildi",
  开心收下: "Qabul qilishdan xursandman",
  助力已结束: "Yordam tugadi",
  助力成功: "Muvaffaqiyatga yordam bering",
  成功: "muvaffaqiyat",
  进行中: "Davom etilmoqda",
  等待: "kuting",
  助力失败: "Yordam muvaffaqiyatsiz tugadi",
  任務: "Tapshirma",
  下单失败_请稍后重试:
    "Buyurtma muvaffaqiyatsiz tugadi, iltimos keyinroq qayta urinib ko'ring",
  任务: "Vazifa"
};
